import { useContext } from 'react';

import {
  ActionsContext,
  type AdminAgentActionsContextValue,
  type AdminAgentPanelContextValue,
  PanelContext,
} from './admin-agent-contexts';

export function useAdminAgentActions(): AdminAgentActionsContextValue {
  const ctx = useContext(ActionsContext);
  if (!ctx) {
    throw new Error('useAdminAgentActions must be used within AdminAgentProvider');
  }
  return ctx;
}

export function useAdminAgentPanel(): AdminAgentPanelContextValue {
  const ctx = useContext(PanelContext);
  if (!ctx) {
    throw new Error('useAdminAgentPanel must be used within AdminAgentProvider');
  }
  return ctx;
}

export function useAdminAgent() {
  return { ...useAdminAgentActions(), ...useAdminAgentPanel() };
}
